import React from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import PageRoutes from '@utils/page-routes'

const PurchaseLearnDialog: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Dialog name="purchase_learn" title={t('content.learnMusicPreview')} maxWidth={400}>
      <p className="whitespace-normal">{t('messages.purchaseLearn')}</p>
      <div className="flex flex-row justify-end w-full mt-4">
        <a
          title={t('action.purchaseLearn')}
          href={PageRoutes.purchaseLearn()}
          className="ml-3 btn btn-primary">
          {t('action.purchaseLearn')}
        </a>
      </div>
    </Dialog>
  )
}

export default PurchaseLearnDialog
